import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { HeroTeaser } from '@vwfs-bronson/bronson-react';

interface Props {
  formData?: any;
}

export const ESignSuccessPage: FunctionComponent<Props> = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeroTeaser
        imgProps={{
          sizes: '100vw',
          src: 'assets/img/bg_imgc.png',
        }}
        title={[
          <>
            <h3 className="u-mb-small" style={{ color: '#ffffff' }}>
              {t('eSignSuccessPage:title1')}
            </h3>
            <p className="u-font-size-fs3">{t('eSignSuccessPage:text1')}</p>
          </>,
        ]}
        sub={
          <>
            <h3 className="u-mb-small" style={{ color: '#ffffff' }}>
              {t('eSignSuccessPage:title2')}
            </h3>
            <p style={{ fontWeight: 700, lineHeight: '1.2' }} className="u-font-size-fs3">
              {t('eSignSuccessPage:text2')}
            </p>
          </>
        }
      />
    </>
  );
};
